<template>
  <v-layout 
    row 
    wrap>
    <v-flex 
      xs12 
      md6 
      offset-md3>
      <app-display-friends v-if="!searchActive"></app-display-friends>
      <app-search-friends v-else></app-search-friends>
    </v-flex>
  </v-layout>
</template>


<script>
import DisplayFriends    from '@/components/View_Friends/DisplayFriends.vue'
import SearchFriends    from '@/components/View_Friends/SearchFriends.vue'

import { mapState } from 'vuex'


export default {
  components: {
    // eslint-disable-next-line
    "app-display-friends": DisplayFriends,
    // eslint-disable-next-line
    "app-search-friends": SearchFriends,
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState({
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      searchActive: state => state.searchActive
    }),
  }
}
</script>
